import { CarouselItem } from './types';

export const CAROUSEL_DATA: CarouselItem[] = [
  {
    url: '/img/illustration_1.svg',
    title: 'Biaya Broker yang Rendah',
    description: 'Fee beli 0,15%. Fee jual 0,25%',
  },
  {
    url: '/img/illustration_2.svg',
    title: 'Gratis Stockbit Pro',
    description: 'Setiap nasabah dapat akses Stockbit Pro tanpa biaya.',
  },
  {
    url: '/img/illustration_4.svg',
    title: 'Tanpa Minimal Deposit',
    description: 'Mulai investasi tanpa modal besar.',
  },
  {
    url: '/img/illustration_5.svg',
    title: 'Buka Rekening 1 Hari Kerja',
    description: 'Tanpa perlu kirim dokumen fisik.',
  },
];
